import { conditionInterpretator } from './scene_conditions_to_ui';
import { actionInterpretator } from './scene_actions_to_ui';
import { getSceneActions, getSceneConditions, asSceneList } from './scene_data_helpers';
import type { DeviceCondition_UI } from '../../../types/DeviceCondition_UI';
import { _findOrIndex } from '../../../helpers/handle_manage_old_scenes';

export const check_for_broken_conditions = (conditions) => {
	const list = asSceneList(conditions);
	if (list.length === 0) return true;
	for (let _element of list) {
		for (let element of asSceneList(_element.and)) {
			let purpose = element._gui_type || element._gui_purpose || undefined;

			let tr = conditionInterpretator(element, purpose);
			/** If the interpratator does not match any known formats, then it is a broken condition */
			if (tr === undefined) {
				return true;
			}
		}
	}
	return false;
};

export const check_for_broken_actions = (actions) => {
	const list = asSceneList(actions);
	if (list.length === 0) return true;
	for (let element of list) {
		// console.log(element);
		let purpose =
			element._gui_type ||
			element._gui_purpose ||
			element?.do?.blk[0]?._gui_type ||
			element?.do?.blk[0]?._gui_purpose ||
			undefined;
		let e = element?.do?.blk ? element.do.blk[0] : element;
		let tr = actionInterpretator(purpose, e, element.msg_type);

		/** If the interpratator does not match any known formats, then it is a broken action */
		if (tr === undefined) {
			return true;
		}
	}

	return false;
};

export const check_for_broken_conditions_or_actions = (scene) => {
	let conditions = getSceneConditions(scene);
	let actions = getSceneActions(scene);

	return check_for_broken_actions(actions) || check_for_broken_conditions(conditions);
};

export const validate_indaily_condition = (indailyint_obj) => {
	let { indailyint } = indailyint_obj;

	if (
		typeof indailyint !== 'object' ||
		!indailyint.dows ||
		indailyint.dows === '' ||
		!indailyint.startat ||
		indailyint.startat === '' ||
		indailyint.dur < 1
	) {
		return false;
	}
	return true;
};
//#region validation of temp elements
export const validate_ui_device_condition_format = (translated: DeviceCondition_UI): boolean => {
	/** Validate keys */
	let required = ['value', 'id', 'cond_type'];
	/**check required*/
	for (let _k of required) {
		if (typeof translated[_k] === 'undefined' || translated[_k] === '') {
			return false;
		}
		if (_k === 'cond_type' && [undefined, ''].includes(translated[_k]?.id?.toString())) {
			return false;
		}
	}

	/**
	 * if found operator, check input value
	 */
	if (typeof translated['operator'] !== 'undefined') {
		//if operator is less than or great than sanitize the input
		if (
			!['', 'equal'].includes(translated['operator']) &&
			typeof translated['input'] === undefined
		) {
			false;
		}
	}
	return true;
};

export const validate_ui_time_based_format = (translated) => {
	if (typeof translated._gui_type === 'undefined' || translated._gui_type === '') {
		return false;
	}

	if (
		!translated.value ||
		(typeof translated.value === 'object' &&
			(translated.value.time === '' || translated.value.time === undefined))
	) {
		return false;
	}
	if (translated._gui_type === 'd_cond' && typeof translated.value === 'object') {
		if (
			typeof translated.value.isin === 'undefined' ||
			translated.value.isin.length === 0 ||
			translated.value.isin.find((e) => isNaN(Number(e)))
		) {
			return false;
		}
	}
	return true;
};

export const validate_ui_device_action_format = (translated) => {
	if (translated.actions === undefined || translated.actions.length === 0) {
		return false;
	}
	return true;
};

export const validate_ui_notify_format = (translated) => {
	if (!translated.msg_type || translated.msg_type === '') {
		return false;
	}
	return true;
};

//#endregion validation of temp elements
export const validate_scene = (scene) => {
	//1. check for conditions
	//2. check for actions
	//3. check meta
	if (!scene.if) {
		//|| !scene.if.and){
		//open modal with alert
		//You don't have set up conditions
		return false;
	}
	//if we have and => search for main OR and check if it has length
	if (scene?.if?.and) {
		let orIndex = _findOrIndex(scene);

		if (orIndex === -1 || scene.if.and[orIndex].or.length === 0) {
			//open modal with alert
			//You don't have set up conditions
			return false;
		}
		/**check the id of OR conditions, because of old UI scene view and creation to avoid wrong scene scripts
		 *and to be sure that there is no any unexpected behaviors -> different scene execution from the old UI */
		if (_findOrIndex(scene) == 0) {
			scene.if.and.reverse();
			// console.log('ON SAVE SCENE reverse indailyint in and');
		}
	} else if (scene?.if?.or?.length === 0) {
		return false;
	}

	if (getSceneActions(scene).length === 0) {
		return false;
	}

	if (
		!scene._meta ||
		!scene?._meta?.name ||
		scene?._meta?.name === '' ||
		(!scene?._meta?.image && !scene?._meta?.backgroundColor) ||
		(scene?._meta?.image === '' && scene?._meta?.backgroundColor === '')
	)
		return false;

	return true;
};
